/**
 * DataManagementCard - Data export and management
 */
export default function DataManagementCard() {
  return (
    <div 
      className="card"
      style={{ 
        borderColor: 'var(--color-category-6)',
        backgroundColor: 'rgba(189, 166, 110, 0.08)',
      }}
    >
      <div className="card-header" style={{ borderColor: 'var(--color-category-6)' }}>
        <h3 className="font-semibold" style={{ color: 'var(--color-category-6)' }}>Data Management</h3>
      </div>
      <div className="card-body">
        <p className="text-sm mb-4" style={{ color: 'var(--color-text-secondary)' }}>
          Your data is stored securely in Cloudflare's infrastructure. Only you have access to your itinerary through Cloudflare Access authentication.
        </p>
        <div className="flex items-center gap-3">
          <button className="btn-secondary btn-sm">
            Export Data
          </button>
          <span className="text-xs" style={{ color: 'var(--color-text-muted)' }}>(Coming soon)</span>
        </div>
      </div>
    </div>
  );
}
